import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { faEye } from '@fortawesome/free-solid-svg-icons';

function ComplaintList() {
    const [complaints, setComplaints] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [attachmentUrl, setAttachmentUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [fileBlobUrl, setFileBlobUrl] = useState(null);
    const [feedbackPopup, setFeedbackPopup] = useState({
        show: false,
        content: '',
        id: null,
        isEditing: false
    });
    
    useEffect(() => {
        fetch('https://chaman.gob.pk/eac_backend/get_complaint.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'get_records' }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('API Response:', data);
                setComplaints(data);
            })
            .catch((error) => console.error('Error fetching complaints:', error));
    }, []);

    const truncateText = (text, wordLimit = 6) => {
        if (!text) return '';
        const words = text.split(' ');
        if (words.length > wordLimit) {
            return words.slice(0, wordLimit).join(' ') + '...';
        }
        return text;
    };

    const handleFeedbackClick = (content, id) => {
        setFeedbackPopup({
            show: true,
            content: content || 'No feedback provided',
            id: id,
            isEditing: false
        });
    };

    const handleChange = (e, id, field) => {
        const updatedComplaints = complaints.map((complaint) => {
            if (complaint.id === id) {
                return { ...complaint, [field]: e.target.value };
            }
            return complaint;
        });
        setComplaints(updatedComplaints);
    };

    const handleSubmit = (complaint) => {
        console.log('Updating complaint:', complaint);
        fetch('https://chaman.gob.pk/eac_backend/update_complaint.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(complaint),
        })
            .then((response) => response.text())
            .then(() => {
                setShowPopup(true);
                setTimeout(() => {
                    setShowPopup(false);
                }, 2000);
            })
            .catch((error) => console.error('Error updating complaint:', error));
    };

    const openModal = (filePath) => {
        setAttachmentUrl(filePath);
        setLoading(true);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setAttachmentUrl('');
        setFileBlobUrl(null);
    };

    const handleImageLoad = () => {
        setLoading(false);
    };

    const autoResize = (e) => {
        e.target.style.height = 'auto';
        e.target.style.height = e.target.scrollHeight + 'px';
    };

    const downloadAndPreviewFile = (filePath) => {
        fetch(`https://chaman.gob.pk/eac_backend/${filePath}`)
            .then((response) => response.blob())
            .then((blob) => {
                const url = URL.createObjectURL(blob);
                setFileBlobUrl(url);
                // Open the URL in a new tab
                const newTab = window.open(url, '_blank');
                // Ensure the file will be displayed in the new tab
                if (newTab) {
                    newTab.focus();
                } else {
                    console.error('Failed to open a new tab. Please check your browser settings.');
                }
            })
            .catch((error) => console.error('Error downloading file:', error));
    };
    

    const handleRightClick = (e, filePath) => {
        e.preventDefault();
        fetch(`https://chaman.gob.pk/eac_backend/${filePath}`)
            .then((response) => response.blob())
            .then((blob) => {
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            })
            .catch((error) => console.error('Error opening file in new tab:', error));
    };

    const handleFeedbackEdit = () => {
        setFeedbackPopup(prev => ({ ...prev, isEditing: true }));
    };

    const handleFeedbackSave = () => {
        const { id, content } = feedbackPopup;
        const updatedComplaints = complaints.map(complaint => {
            if (complaint.id === id) {
                return { ...complaint, feedback: content };
            }
            return complaint;
        });
        setComplaints(updatedComplaints);
        
        // Find the complaint to save
        const complaintToUpdate = updatedComplaints.find(c => c.id === id);
        if (complaintToUpdate) {
            handleSubmit(complaintToUpdate);
        }
        
        setFeedbackPopup(prev => ({ ...prev, isEditing: false }));
    };

    const handleFeedbackChange = (e) => {
        setFeedbackPopup(prev => ({ ...prev, content: e.target.value }));
    };

    return (
        <>
            <div className='ct'>
                <div className="table-wrapper">
                    <table id='complainttable'>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                <th>Complaint</th>
                                <th>Priority</th>
                                <th>Status</th>
                                <th>Feedback</th>
                                <th>Attachment</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(complaints) ? (
                                complaints.map((complaint) => (
                                    <tr key={complaint.id}>
                                        <td>{complaint.id}</td>
                                        <td>{complaint.name}</td>
                                        <td>{complaint.email}</td>
                                        <td>{complaint.complaint}</td>
                                        <td>
                                            <select
                                                id='csc'
                                                value={complaint.priority || 'moderate'}
                                                onChange={(e) => handleChange(e, complaint.id, 'priority')}
                                            >
                                                <option value="poor">Poor</option>
                                                <option value="moderate">Moderate</option>
                                                <option value="high">High</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select
                                                id='csc'
                                                value={complaint.status || 'open'}
                                                onChange={(e) => handleChange(e, complaint.id, 'status')}
                                            >
                                                <option value="open">Open</option>
                                                <option value="in-progress">In Progress</option>
                                                <option value="resolved">Resolved</option>
                                            </select>
                                        </td>
                                        <td>
                                            <div 
                                                className="feedback-preview" 
                                                onClick={() => handleFeedbackClick(complaint.feedback, complaint.id)}
                                                style={{
                                                    cursor: 'pointer',
                                                    padding: '8px',
                                                    // border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    minHeight: '40px',
                                                    maxWidth: '200px',
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis'
                                                }}
                                            >
                                                {truncateText(complaint.feedback)}
                                            </div>
                                            <textarea
                                                className='feedback-textarea'
                                                value={complaint.feedback || ''}
                                                onChange={(e) => {
                                                    handleChange(e, complaint.id, 'feedback');
                                                    autoResize(e);
                                                }}
                                                style={{ display: 'none' }}
                                            />
                                        </td>
                                        <td>
                                            {complaint.file_path ? (
                                                <button
                                                    className="listbuttons"
                                                    id="lstbtn"
                                                    onClick={() => openModal(complaint.file_path)}
                                                >
                                                    <FontAwesomeIcon icon={faEye} />
                                                </button>
                                            ) : (
                                                'No Attachment'
                                            )}
                                        </td>
                                        <td>
                                            <div className="listbuttons">
                                                <button id='lstbtn' onClick={() => handleSubmit(complaint)}>
                                                    <FontAwesomeIcon icon={faSave} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9">No complaints available.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {showPopup && (
                        <div style={popupStyle}>
                            Complaint successfully updated!
                        </div>
                    )}

                    {/* Feedback Popup */}
                    {feedbackPopup.show && (
                        <div style={feedbackModalStyle}>
                            <div style={feedbackModalContentStyle}>
                                <span 
                                    style={closeButtonStyle} 
                                    onClick={() => setFeedbackPopup({ show: false, content: '', id: null, isEditing: false })}
                                >
                                    &times;
                                </span>
                                <div style={feedbackContentStyle}>
                                    {feedbackPopup.isEditing ? (
                                        <textarea
                                            value={feedbackPopup.content}
                                            onChange={handleFeedbackChange}
                                            style={{
                                                width: '96.5%',
                                                minHeight: '200px',
                                                padding: '10px',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px'
                                            }}
                                        />
                                    ) : (
                                        <div style={{ whiteSpace: 'pre-wrap' }}>
                                            {feedbackPopup.content}
                                        </div>
                                    )}
                                </div>
                                <div style={feedbackButtonContainerStyle}>
                                    {feedbackPopup.isEditing ? (
                                        <button 
                                            style={feedbackButtonStyle}
                                            onClick={handleFeedbackSave}
                                        >
                                            Save
                                        </button>
                                    ) : (
                                        <button 
                                            style={feedbackButtonStyle}
                                            onClick={handleFeedbackEdit}
                                        >
                                            Edit
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Attachment Modal */}
                    {modalOpen && (
                        <div style={modalStyle}>
                            <div style={modalContentStyle}>
                                <span style={closeButtonStyle} onClick={closeModal}>&times;</span>
                                <div style={attachmentContainerStyle}>
                                    {loading && <div style={loadingStyle}>Loading...</div>}
                                    {attachmentUrl && (
                                        <>
                                            {attachmentUrl.endsWith('.pdf') ? (
                                                <embed
                                                    src={`https://chaman.gob.pk/eac_backend/${attachmentUrl}`}
                                                    type="application/pdf"
                                                    width="100%"
                                                    height="600px"
                                                />
                                            ) : attachmentUrl.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                                                <img
                                                    src={`https://chaman.gob.pk/eac_backend/${attachmentUrl}`}
                                                    alt="Attachment"
                                                    style={{ width: '100%', height: 'auto', maxHeight: '80vh' }}
                                                    onLoad={handleImageLoad}
                                                    loading="lazy"
                                                />
                                            ) : attachmentUrl.match(/\.(txt)$/i) ? (
                                                <iframe
                                                    src={`https://chaman.gob.pk/eac_backend/${attachmentUrl}`}
                                                    width="100%"
                                                    height="600px"
                                                />
                                            ) : attachmentUrl.match(/\.(docx|xlsx|pptx)$/i) ? (
                                                <div>
                                                    <a
                                                        href={`https://chaman.gob.pk/eac_backend/${attachmentUrl}`}
                                                        download
                                                    >
                                                        Download {attachmentUrl}
                                                    </a>
                                                </div>
                                            ) : (
                                                <><p>Download it below:</p><a
                                                    href={`https://chaman.gob.pk/eac_backend/${attachmentUrl}`}
                                                    download
                                                >
                                                    Download {attachmentUrl}
                                                </a></>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

// Styles
const popupStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    padding: '10px 20px',
    backgroundColor: '#3b82f6',
    color: 'white',
    borderRadius: '5px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
    zIndex: 1000,
};

const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
};

const modalContentStyle = {
    position: 'relative',
    backgroundColor: '#fff',
    padding: '20px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
};

const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    fontSize: '30px',
    cursor: 'pointer',
    color: '#333',
};

const attachmentContainerStyle = {
    maxHeight: '80vh',
    overflow: 'auto',
};

const loadingStyle = {
    textAlign: 'center',
    fontSize: '20px',
    color: '#333',
    marginBottom: '20px',
};

// Feedback Popup Styles
const feedbackModalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
};

const feedbackModalContentStyle = {
    position: 'relative',
    backgroundColor: '#fff',
    padding: '30px',
    width: '60%',
    maxWidth: '600px',
    maxHeight: '80vh',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
};

const feedbackContentStyle = {
    maxHeight: '60vh',
    overflowY: 'auto',
    padding: '10px',
    border: '1px solid #eee',
    borderRadius: '4px',
    wordWrap: 'break-word',
    marginBottom: '15px'
};

const feedbackButtonContainerStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '15px'
};

const feedbackButtonStyle = {
    padding: '8px 16px',
    backgroundColor: '#399918',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px'
};

export default ComplaintList;